import { createSlice } from '@reduxjs/toolkit';

export const routerSlice = createSlice({
  name: 'locale',
  initialState: {
  	value: 'en'
  },
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setPathNameVal: (state, actions) => {
      state.value = actions.payload;
    }
  }
});
export const selectPathName = (state:any) => state.locale.value;
export const { setPathNameVal } = routerSlice.actions;

export default routerSlice.reducer;